/* unplugin-vue-components disabled */import { render } from "./TextLogicalReasoningQuestion.vue?vue&type=template&id=32fc4b6a&scoped=true"
import script from "./TextLogicalReasoningQuestion.vue?vue&type=script&lang=js"
export * from "./TextLogicalReasoningQuestion.vue?vue&type=script&lang=js"

import "./TextLogicalReasoningQuestion.vue?vue&type=style&index=0&id=32fc4b6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fc4b6a"]])

export default __exports__